(() => {
  const body = document.body;
  if (!body.classList.contains('monea-minimal-template')) return;

  const normalize = (value='') => value.toString().trim().toLowerCase();
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
        style:'currency',
        currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
        maximumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format(cents / 100);
    } catch(e) {
      return (cents/100).toFixed(2) + ' €';
    }
  };

  const store = document.querySelector('[data-monea-store]');
  if (store) {
    const cards = [...store.querySelectorAll('.monea-min-card')];
    const grid = store.querySelector('[data-monea-grid]');
    let gender = new URLSearchParams(location.search).get('gender') || 'male';
    let type = 'all';
    let sort = 'default';

    const filterPanel = store.querySelector('[data-monea-filter-panel]');

    const openFilters = () => {
      filterPanel?.classList.add('is-open');
      filterPanel?.setAttribute('aria-hidden','false');
    };
    const closeFilters = () => {
      filterPanel?.classList.remove('is-open');
      filterPanel?.setAttribute('aria-hidden','true');
    };

    document.querySelectorAll('[data-monea-filter-open]').forEach(el => el.addEventListener('click', openFilters));
    document.querySelectorAll('[data-monea-filter-close]').forEach(el => el.addEventListener('click', closeFilters));

    if (new URLSearchParams(location.search).get('filters') === '1') {
      setTimeout(openFilters, 120);
    }

    const isVisible = (card) => {
      const cg = card.dataset.gender;
      const genderMatch = cg === 'both' || cg === gender;
      const typeMatch = type === 'all' || (card.dataset.types || '').split(/\s+/).includes(type);
      return genderMatch && typeMatch;
    };

    const defaultCompare = (a,b) => {
      const pa = Number(a.dataset.phase || 3);
      const pb = Number(b.dataset.phase || 3);
      if (pa !== pb) return pa - pb;
      if (pa === 1) return Number(b.dataset.created) - Number(a.dataset.created);
      return Number(a.dataset.rank) - Number(b.dataset.rank);
    };

    const sortCompare = (a,b) => {
      if (sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
      if (sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
      if (sort === 'newest') return Number(b.dataset.created) - Number(a.dataset.created);
      return defaultCompare(a,b);
    };

    const apply = () => {
      cards.sort(sortCompare).forEach(card => grid.appendChild(card));
      cards.forEach(card => card.hidden = !isVisible(card));
      document.querySelectorAll('[data-monea-gender]').forEach(btn => {
        const active = btn.dataset.moneaGender === gender;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true':'false');
      });
      const url = new URL(location.href);
      url.searchParams.set('gender', gender);
      url.searchParams.delete('filters');
      history.replaceState({},'',url);
    };

    document.querySelectorAll('[data-monea-gender]').forEach(btn => {
      btn.addEventListener('click', () => {
        gender = btn.dataset.moneaGender;
        apply();
        window.scrollTo({top:0,behavior:'smooth'});
      });
    });

    store.querySelectorAll('[data-monea-sort]').forEach(btn => {
      btn.addEventListener('click', () => {
        sort = btn.dataset.moneaSort;
        store.querySelectorAll('[data-monea-sort]').forEach(x => x.classList.toggle('is-active',x===btn));
        apply();
      });
    });

    store.querySelectorAll('[data-monea-type]').forEach(btn => {
      btn.addEventListener('click', () => {
        type = btn.dataset.moneaType;
        store.querySelectorAll('[data-monea-type]').forEach(x => x.classList.toggle('is-active',x===btn));
        apply();
      });
    });

    apply();

    const sheet = store.querySelector('[data-monea-quick-sheet]');
    const titleEl = store.querySelector('[data-monea-quick-title]');
    const optionsEl = store.querySelector('[data-monea-quick-options]');
    const addBtn = store.querySelector('[data-monea-quick-add]');
    const statusEl = store.querySelector('[data-monea-quick-status]');
    let currentProduct = null;
    let selected = [];

    const closeSheet = () => {
      sheet?.classList.remove('is-open');
      sheet?.setAttribute('aria-hidden','true');
      currentProduct = null;
      selected = [];
    };

    store.querySelector('[data-monea-quick-close]')?.addEventListener('click', closeSheet);
    sheet?.addEventListener('click', (e) => {
      if (e.target === sheet) closeSheet();
    });

    const selectedVariant = () => {
      if (!currentProduct) return null;
      return currentProduct.variants.find(v => {
        const opts = v.options || [v.option1,v.option2,v.option3].filter(Boolean);
        return opts.every((o,i) => o === selected[i]);
      });
    };

    const renderOptions = (meta, reset = true) => {
      currentProduct = meta.product;
      const optionNames = (meta.optionNames || currentProduct.options || []).map(o => typeof o === 'string' ? o : o.name);
      const variants = currentProduct.variants || [];

      if (!optionNames.length || (optionNames.length === 1 && normalize(optionNames[0]) === 'title')) {
        selected = [];
        optionsEl.innerHTML = '';
        addBtn.disabled = !(variants[0] && variants[0].available !== false);
        return;
      }

      if (reset || selected.length !== optionNames.length) {
        selected = optionNames.map((_,i) => {
          const firstAvailable = variants.find(v => v.available !== false);
          const opts = firstAvailable ? (firstAvailable.options || [firstAvailable.option1,firstAvailable.option2,firstAvailable.option3].filter(Boolean)) : [];
          return opts[i] || '';
        });
      }

      optionsEl.innerHTML = '';
      optionNames.forEach((name, index) => {
        const wrap = document.createElement('div');
        wrap.className = 'monea-quick-option';
        const label = document.createElement('span');
        label.textContent = name;
        const values = document.createElement('div');
        values.className = 'monea-quick-option__values';

        const unique = [];
        variants.forEach(v => {
          const opts = v.options || [v.option1,v.option2,v.option3].filter(Boolean);
          const val = opts[index];
          if (val && !unique.includes(val)) unique.push(val);
        });

        unique.forEach(value => {
          const b = document.createElement('button');
          b.type = 'button';
          b.textContent = value;
          b.classList.toggle('is-active', selected[index] === value);
          b.addEventListener('click', () => {
            selected[index] = value;
            renderOptions(meta, false);
          });
          values.appendChild(b);
        });

        wrap.append(label, values);
        optionsEl.appendChild(wrap);
      });

      const variant = selectedVariant();
      addBtn.disabled = !variant || variant.available === false;
    };

    store.querySelectorAll('[data-monea-quick-open]').forEach(btn => {
      btn.addEventListener('click', () => {
        const card = btn.closest('.monea-min-card');
        const script = card?.querySelector('.monea-min-product-json');
        if (!script) return;
        const meta = JSON.parse(script.textContent);
        titleEl.textContent = meta.product.title;
        statusEl.textContent = '';
        renderOptions(meta);
        sheet.classList.add('is-open');
        sheet.setAttribute('aria-hidden','false');
      });
    });

    addBtn?.addEventListener('click', async () => {
      const variants = currentProduct?.variants || [];
      let variant = selectedVariant();
      if (!variant && variants.length === 1) variant = variants[0];
      if (!variant) return;

      addBtn.disabled = true;
      statusEl.textContent = 'ADDING…';
      try {
        const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:variant.id,quantity:1}]})
        });
        if (!res.ok) throw new Error('add');
        const cart = await fetch(window.routes?.cart_url + '.js' || '/cart.js').then(r=>r.json());
        document.querySelectorAll('[data-monea-cart-count]').forEach(el => el.textContent = '(' + cart.item_count + ')');
        statusEl.textContent = 'ADDED';
        setTimeout(closeSheet, 650);
      } catch(e) {
        statusEl.textContent = 'TRY AGAIN';
        addBtn.disabled = false;
      }
    });

    const emailPop = store.querySelector('[data-monea-email-pop]');
    const emailKey = 'monea_email_pop_closed_v1';
    if (emailPop && !localStorage.getItem(emailKey)) {
      setTimeout(() => { emailPop.hidden = false; }, 6000);
    }
    store.querySelector('[data-monea-email-close]')?.addEventListener('click', () => {
      emailPop.hidden = true;
      localStorage.setItem(emailKey,'1');
    });
  }

  const colorMap = {
    'black':'#242321',
    'white':'#F6F1E8',
    'white with black':'#E7E2D8',
    'white gray':'#D5D2CB',
    'dark gray':'#555552',
    'flower gray':'#AAA7A0',
    'gray green':'#7D8B78',
    'green camo':'#69705C',
    'khaki':'#B2A58E',
    'grass green':'#6B8E52',
    'blue':'#6F8796',
    'sky blue':'#9EB7C4',
    'haze blue':'#8FA8B5',
    'static blue':'#708CA0',
    'jeans blue':'#6F8796',
    'navy blue':'#35485A',
    'royal blue':'#4E6E98',
    'dark red with black':'#603A3B',
    'red':'#9B3D3D',
    'cream':'#F3EBDD',
    'beige':'#C9BCA8'
  };

  const luminanceText = (hex) => {
    const v = hex.replace('#','');
    if (v.length !== 6) return '#fff';
    const rgb=[0,2,4].map(i=>parseInt(v.slice(i,i+2),16)/255).map(c=>c<=.03928?c/12.92:Math.pow((c+.055)/1.055,2.4));
    const lum=.2126*rgb[0]+.7152*rgb[1]+.0722*rgb[2];
    return lum > .56 ? '#242321' : '#FBF8F2';
  };

  const updateProductAccent = () => {
    if (body.dataset.moneaPage !== 'product') return;
    const picker = document.querySelector('variant-selects');
    if (!picker) return;

    picker.querySelectorAll('.product-form__input--pill').forEach(field => {
      const legend = normalize(field.querySelector('legend')?.textContent);
      field.classList.toggle('monea-size-option', legend.includes('size') || legend.includes('taglia'));
    });

    let colorValue = '';
    picker.querySelectorAll('input:checked[data-option-name], select').forEach(el => {
      const optionName = normalize(el.dataset.optionName || el.name || el.closest('.product-form__input')?.querySelector('.form__label')?.textContent);
      if (optionName.includes('color') || optionName.includes('colour') || optionName.includes('colore')) {
        colorValue = el.value;
      }
    });

    if (!colorValue) {
      const colorInput = [...picker.querySelectorAll('[data-option-name]')].find(el => {
        const n=normalize(el.dataset.optionName);
        return n.includes('color') || n.includes('colour') || n.includes('colore');
      });
      if (colorInput) colorValue = colorInput.value;
    }

    const key = normalize(colorValue);
    const hex = colorMap[key] || '#242321';
    body.style.setProperty('--monea-variant-accent',hex);
    body.style.setProperty('--monea-variant-accent-text',luminanceText(hex));
  };

  updateProductAccent();
  document.addEventListener('change', (e) => {
    if (e.target.closest('variant-selects')) setTimeout(updateProductAccent, 30);
  });
  if (body.dataset.moneaPage === 'product') {
    const obs = new MutationObserver(() => updateProductAccent());
    const productRoot = document.querySelector('#MainContent');
    if (productRoot) obs.observe(productRoot,{subtree:true,childList:true});
  }
})();